import {Hawa_1, Samuel_Tiokeng1, Samuel_Tiokeng2, Samuel_Tiokeng3, camsol_logo1, cms10_eric, cms11_leo, cms12_Delor, cms13_jubal, cms14_steph, cms15_jeanne, cms16_Jume, cms17_francktch, cms18_david, cms19_johanah, cms1_CEO,cms20_Ramish,cms21_simon,cms22_francesBeri,cms23_Schmidt,cms24_Herbert,cms25_Stephen,cms2_max,cms3_moh,cms4_Tobi, cms5_Alice, cms6_carine, cms7_Ngoran, cms8_Elma, cms9_Muma, myles_1} from '../images'
export const companyStructuralData = [
  // {
  //   companyName:"Google",
  //   companyHeadOfficeLocation:"Austin, Texas, United States",
  //
  // },
  {
    companyName:"Oracle",
    companyHeadOfficeLocation:"Austin, Texas, United States",
    companyLevel1:[
      {
        name:"Oracle Executive Leadership",
        people:[

          {
            name:'Safra A. Catz',
            photo:'https://www.gsb.stanford.edu/sites/default/files/styles/270_x_270/public/person_photos/catz-safra-a_0.jpg?itok=obMspJYv',
            title:'Chief Executive Officer',
            BiographyP1:'Safra A. Catz has served as chief executive officer of Oracle Corporation since 2014 and a member of the company’s board of directors since 2001. She previously served as president of Oracle and has also served as the company’s chief financial officer. Prior to being named president, Catz held various other positions since starting at Oracle in 1999. She currently serves as a director of The Walt Disney Company and previously served as a director of HSBC Holdings plc',
            source:[
              {
                name:"Oracle",
                link:"https://www.oracle.com/sa/corporate/executives/"
              }
            ],
            report1:[
              {
                name:'Joyce Westerdahl',
                photo:'https://cdn.theorg.com/49d4941e-b5ca-43cb-8cad-2f7f495c498a_medium.png',
                title:'EVP, Human Resources',
                BiographyP1:"Joyce Westerdahl is leading Oracle HR’s cloud transformation to ensure that business leaders and more than 135,000 employees are enabled to achieve Oracle’s mission to be the number one cloud company in the world. Since taking the lead of Oracle HR in 2000, she has continuously implemented a roadmap of progressive HR modernization initiatives intended to keep Oracle at the leading edge of technology innovation.",
                source:[
                  {
                    name:"theorg",
                    link:"https://theorg.com/org/oracle/org-chart/joyce-westerdahl"
                  }
                ],
                report2:[
                  {
                    name:'Anje Dodson',
                    photo:'https://cdn.theorg.com/d607ce51-3681-4bfa-b0a8-a76e081ead0b_medium.jpg',
                    title:'SVP, HR',
                    BiographyP1:'No BiographyP1',
                    source:[
                      {
                        name:"Oracle",
                        link:"https://www.oracle.com/sa/corporate/executives/"
                      }
                    ]
                  },

                  {
                    name:'Christie Book',
                    photo:'https://cdn.theorg.com/302d4511-4084-43fb-aa2e-16fe6345795f_medium.jpg',
                    title:'SVP, Global Executive Recruiting',
                    BiographyP1:'No BiographyP1',
                    source:[
                      {
                        name:"Oracle",
                        link:"https://www.oracle.com/sa/corporate/executives/"
                      }
                    ]
                  },

                  {
                    name:'Peter Shott',
                    photo:'https://cdn.theorg.com/76f5eab5-e896-4334-b95b-c32a8d0f8549_medium.jpg',
                    title:'SVP,HR',
                    BiographyP1:'No BiographyP1',
                    source:[
                      {
                        name:"Oracle",
                        link:"https://www.oracle.com/sa/corporate/executives/"
                      }
                    ]
                  },
                  {
                    name:'Vickie Thrasher',
                    photo:'https://cdn.theorg.com/7faa5a5d-f33c-45e9-9331-e53e5f3e5241_medium.jpg',
                    title:'SVP,HR, Organization and People Capability',
                    BiographyP1:'No BiographyP1',
                    source:[
                      {
                        name:"Oracle",
                        link:"https://www.oracle.com/sa/corporate/executives/"
                      }
                    ]
                  },
                  {
                    name:'Vance Kearney',
                    photo:'https://www.hrmagazine.co.uk/media/ro4dtsbz/article-images-2f95526-2fvancekearney.jpg',
                    title:'SVP, HR EMEA',
                    BiographyP1:'No BiographyP1',
                    source:[
                      {
                        name:"Oracle",
                        link:"https://www.oracle.com/sa/corporate/executives/"
                      }
                    ],
                    report3:[
                      {
                        name:'Claire Bennett',
                        photo:'https://cdn.theorg.com/6ab278e8-00fa-4b34-b2f4-2910cfd86211_medium.jpg',
                        title:'VP, HR - EMEA',
                        phoneNumber:'',
                        email:"",
                        website:"",
                        address:"United Kingdom",
                        linkedIn:"linkedin.com/in/claire-bennett-461478",
                        Education:[
                          {

                            year:"2002 - 2003",
                            certificateName:"MSC, Human Resources ManagementMSC, Human Resources Management",
                            certificatePoints:"Distinction",
                            institutionName:"University of Portsmouth",
                          },
                          {
                            year:"1996 - 1998",
                            certificateName:"IPD Qualification",
                            certificatePoints:"unknown points",
                            institutionName:"University of Portsmouth",
                          },
                          {
                            year:"1991 - 1994",
                            certificateName:"BSC - English & Classics",
                            certificatePoints:"unknown points",
                            institutionName:"Keele University",
                          },



                        ],
                        languages:[
                          {
                            languageName:"English",
                            languagesPercent:"95%"
                          }
                        ],
                        BiographyP1:'Executive level HR Professional with extensive International knowledge & Overseas experience. Results driven & able to respond to complex and challenging business situations with complimentary HR strategies',
                        BiographyP2:"Specialties: HR Strategy, HR Business Partnering, Organisation Design, Business Transformation, Global Project & Programme Management, Leadership, Consultancy, Trusted Advisor",
                        BiographyP3:"",
                        BiographyP4:"",
                        BiographyP5:"",
                        Experience:[
                          {
                            yearsOfExperience:"Dec 2017 - Present 2022",
                            placeOfExperience:"Oracle",
                            locationOfExperience:"location unknown!!!",
                            areaOfExpertise:"Vice President, EMEA Human Resources",
                            descOfWorkDoneInAreaOfExpertise:"HR Leader, focused on providing strategic HR Partnering to Executive Vice President Applications, EMEA & JAPAC. Focused on Optimising Business Performance, Executive Leadership, Organisation Design and Transformation. Responsible for leading a team of Senior HRBPs who align with EMEA based Executives (Senior Vice Presidents / Vice Presidents) within the License Organisation,",
                          },
                          {
                            yearsOfExperience:"Apr 2015 - Present 2022",
                            placeOfExperience:"Oracle",
                            locationOfExperience:"United Kingdom",
                            areaOfExpertise:"Senior Director, Human Resources, EMEA",
                            descOfWorkDoneInAreaOfExpertise:"- Determination of strategic HR direction for Oracle Applications Business across all EMEA countries, including Cloud transformation across all SaaS product lines - Leadership responsibility for a team of Snr HR Business Partners, supporting multiple License Sales Organisations (inc. Apps, Tech, Alliances & Channels) across EMEA countries - Trusted Advisor & Exec level engagement with Oracle EMEA Senior Vice Presidents - Experienced in managing complex Change Management activities, Organisation Design, Business Transformation, Sales Compensation, Consultation, Workforce Planning, Exec Talent Management - Skilled in integrating Acquired Companies into both new & existing Lines of Business",
                          },

                          {
                            yearsOfExperience:"Mar 2010 - May 2013",
                            placeOfExperience:"Oracle",
                            locationOfExperience:"location unknown",
                            areaOfExpertise:" Senior HR Business Partner, EMEA",
                            descOfWorkDoneInAreaOfExpertise:"Partnering with SVP's & Executive Leadership teams to deliver strategic HR initiatives across Western Europe Applications Responsible for organisation design, change management, business transformation, executive coaching, strategic projects, restructuring across EMEA region Global Project Leadership : Employee Insight Survey, HR Analytics",
                          },
                          {
                            yearsOfExperience:"1994 - 1998",
                            placeOfExperience:"Southern Water",
                            locationOfExperience:"location unknown",
                            areaOfExpertise:"Senior HR Officer",
                            descOfWorkDoneInAreaOfExpertise:"",
                          },
                          {
                            yearsOfExperience:"1998 - 2000",
                            placeOfExperience:"Scottish Power",
                            locationOfExperience:"location unknown",
                            areaOfExpertise:"HR Manager ",
                            descOfWorkDoneInAreaOfExpertise:"HR responsibility for 400 employees on multiple sites within the Engineering &amp; Technical Division",
                          },
                          {
                            yearsOfExperience:"May 2013 - Apr 2015",
                            placeOfExperience:"Oracle",
                            locationOfExperience:"location unknown",
                            areaOfExpertise:"Director, Human Resources, EMEA",
                            descOfWorkDoneInAreaOfExpertise:"Leadership responsibility for a team of Snr HR Business Partners, supporting Oracle's License Sales Organisation Executive level engagement & provision of strategic HRBP support across multiple lines of business Results oriented, focusing on strong collaboration & engagement with stakeholders Interested in process & programme transformation to improve delivery & reduce complexity",
                          },
                          {
                            yearsOfExperience:"May 2007 - Mar 2010",
                            placeOfExperience:"Sun Microsystems",
                            locationOfExperience:"location unknown",
                            areaOfExpertise:"Global HR Operations & Programme Manager",
                            descOfWorkDoneInAreaOfExpertise:"Member of HR Leadership team, focused on driving functional operational efficiencies and global standardisation of programme design, implementation & delivery across 52 countries Budget responsibility for HR spend, including Sun's global outsourced Shared Services contract HR Leader of Reduction in Force programme across International countries Formation of HR business plan & strategic organisational objectives Member of Shared Services project team, including developing next generation HR Systems & Service Delivery Completion of career development assignment; leadership responsibility for 6 country HR teams across Latin America",
                          },

                          {
                            yearsOfExperience:"2006 -  2007",
                            placeOfExperience:"Sun Microsystems",
                            locationOfExperience:"location unknown",
                            areaOfExpertise:"Senior HR Manager; Service Delivery Project Manger",
                            descOfWorkDoneInAreaOfExpertise:"Member of Management team responsible for the implementation of HR BPO project with Hewitt Associates across EMEA countries Partnered with outsourced provider to jointly manage the operational set up of the Regional Service Centre in Krakow Development of change management and change acceptance techniques for stakeholders",
                          },
                          {
                            yearsOfExperience:"Apr 2004 - May 2006",
                            placeOfExperience:"Sun Microsystems",
                            locationOfExperience:"location unknown",
                            areaOfExpertise:"Head of HR, Asia SouthHead of HR, Asia South",
                            descOfWorkDoneInAreaOfExpertise:"Assignment to Singapore to manage the HR function across Asia South countries Member of Asia South Leadership team, providing strategic HR Business Partnering to executives &amp; directors; Change Management, HR strategy, Succession planning, Coaching Leader of HR Shared Services function responsible for; Mergers &amp; Acquisitions, Outsourcing, Employee Relations, Workforce planning,Country HR representative for media &amp; government enquiries Re-design of flexible benefits programme",
                          },

                          {
                            yearsOfExperience:"Oct 2000 - Apr 2004",
                            placeOfExperience:"Sun Microsystems",
                            locationOfExperience:"location unknown",
                            areaOfExpertise:"HR Business Partner, Global Sales, UKHR Business Partner, Global Sales, UK",
                            descOfWorkDoneInAreaOfExpertise:"Worked with UK Vice President &amp; Global Sales Directors to ensure HR responds to business priorities, adds value &amp; delivers appropriate solutions Focused on Talent management, Organisational competitiveness, Performance Management, Employee Relations",
                          },



                        ],
                        professionalSkills:[
                          {

                            nameOfSkill:"Strategy",
                            persentageOfSkills:"95%",
                          },
                          {
                            nameOfSkill:"Human Resources",
                            persentageOfSkills:"95%",
                          },
                          {
                            nameOfSkill:"Talent Management",
                            persentageOfSkills:"95%",
                          },
                          {
                            nameOfSkill:"Change Management",
                            persentageOfSkills:"95%",
                          },
                          {
                            nameOfSkill:"Outsourcing",
                            persentageOfSkills:"95%",
                          },
                          {
                            nameOfSkill:"Performance Management",
                            persentageOfSkills:"95%",
                          },
                          {
                            nameOfSkill:"Employee Relations",
                            persentageOfSkills:"95%",
                          },
                          {
                            nameOfSkill:"HR Policies",
                            persentageOfSkills:"95%",
                          },
                          {
                            nameOfSkill:"Shared Services",
                            persentageOfSkills:"95%",
                          },
                          {
                            nameOfSkill:"Training",
                            persentageOfSkills:"95%",
                          },
                          {
                            nameOfSkill:"Succession Planning",
                            persentageOfSkills:"95%",
                          },

                        ],
                        Interest:[
                          {
                            // iconOfInterest:"",
                            // nameOfInterest:"",
                          }
                        ],
                        source:[
                          {
                            name:"Oracle",
                            link:"https://www.oracle.com/sa/corporate/executives/"
                          },

                          {
                            name:"contactout.com",
                            link:"https://contactout.com/Claire-Bennett-607265"
                          },

                          {
                            name:"linkedin.com",
                            link:"https://www.linkedin.com/in/claire-bennett-461478/"
                          },

                        ]
                      },
                    ]
                  },
                ]
              },


              {
                name:'Larry Ellison',
                photo:'https://customsitesmedia.usc.edu/wp-content/uploads/sites/59/2016/02/16125644/Ellison_1200x800-824x549.jpg',
                title:'Chairman of the Board and Chief Technology Officer',
                BiographyP1:'Larry Ellison is chairman of Oracle Corporation and chief technology officer. He founded the company in 1977 and served as CEO until September 2014. He also races sailboats, flies planes, and plays tennis and guitar.',
                source:[
                  {
                    name:"Oracle",
                    link:"https://www.oracle.com/sa/corporate/executives/"
                  }
                ]
              },
              {
                name:'Dorian Daley',
                photo:'https://s3.amazonaws.com/spoke-profiles-prod-assets/avatars/210x210h/9d95919f5e9b7504dff44ab99a2d37ac0463cfbb.png',
                title:'Executive Vice President and General Counsel',
                BiographyP1:'Dorian Daley serves as executive vice president and general counsel of Oracle Corporation. She began her career at Oracle in 1992 after spending five years with the commercial litigation group of Landels, Ripley & Diamond in San Francisco. She is a 1986 graduate of the Santa Clara University School of Law and a 1981 graduate of Stanford University. Prior to her appointment as general counsel, Daley was a vice president and associate general counsel for Oracle.',
                source:[
                  {
                    name:"Oracle",
                    link:"https://www.oracle.com/sa/corporate/executives/"
                  }
                ]
              },

              {
                name:'Edward Screven',
                photo:'https://cdn.theorg.com/120898f1-4e9e-48da-bb00-34c99c6a01be_medium.png',
                title:'Chief Corporate Architect',
                BiographyP1:"Edward Screven is chief corporate architect at Oracle. Reporting to Executive Chairman and Chief Technical Officer Larry Ellison, he drives technology and architecture decisions across all Oracle products to ensure that product development is consistent with Oracle's overall strategy. An Oracle veteran since 1986, he is responsible for Oracle's open-source businesses, including Linux, virtualization, and MySQL. Screven also leads company-wide strategic initiatives, including industry standards and security.",
                source:[
                  {
                    name:"Oracle",
                    link:"https://www.oracle.com/sa/corporate/executives/"
                  }
                ]
              },

            ]
          },


        ]
      },

      {
        name:"Oracle Board of Directors",
        people:[
          {
            name:'Larry Ellison',
            photo:'https://customsitesmedia.usc.edu/wp-content/uploads/sites/59/2016/02/16125644/Ellison_1200x800-824x549.jpg',
            title:'Chairman of the Board and Chief Technology Officer',
            BiographyP1:'Larry Ellison is chairman of Oracle Corporation and chief technology officer. He founded the company in 1977 and served as CEO until September 2014. He also races sailboats, flies planes, and plays tennis and guitar.',
            source:[
              {
                name:"Oracle",
                link:"https://www.oracle.com/sa/corporate/executives/"
              }
            ]
          },
          {
            name:'Safra A. Catz',
            photo:'https://www.gsb.stanford.edu/sites/default/files/styles/270_x_270/public/person_photos/catz-safra-a_0.jpg?itok=obMspJYv',
            title:'Chief Executive Officer',
            BiographyP1:'Safra A. Catz has served as chief executive officer of Oracle Corporation since 2014 and a member of the company’s board of directors since 2001. She previously served as president of Oracle and has also served as the company’s chief financial officer. Prior to being named president, Catz held various other positions since starting at Oracle in 1999. She currently serves as a director of The Walt Disney Company and previously served as a director of HSBC Holdings plc',
            source:[
              {
                name:"Oracle",
                link:"https://www.oracle.com/sa/corporate/executives/"
              }
            ]
          },
          {
            name:'Jeffrey O. Henley',
            photo:'https://cdn.theorg.com/d0466e43-024e-4683-b0ed-5ac649e8f37d_small.jpg',
            title:'Vice Chairman of the Board',
            BiographyP1:"Jeffrey O. Henley is vice chairman of Oracle Corporation. He served as Oracle’s chief financial officer and an executive vice president from 1991 to 2004, and has been a member of Oracle’s board of directors since 1995. Henley was chairman of Oracle from 2004 until 2014. He also serves on Oracle’s Executive Management Committee. Prior to joining Oracle in 1991, Henley served as executive vice president and chief financial officer at Pacific Holding Company, a privately held company with diversified interests in manufacturing and real estate, and as executive vice president and chief financial officer at Saga Corporation, a multibillion-dollar food service company. Henley is chair for the Institute for Energy Efficiency at UC Santa Barbara. He also serves on the advisory board for the Dean of Engineering at the university. Henley has a BA in economics from the University of California at Santa Barbara and an MBA in finance from UCLA.",
            source:[
              {
                name:"Oracle",
                link:"https://www.oracle.com/sa/corporate/executives/"
              }
            ]
          },

          {
            name:'Jeffrey S. Berg',
            photo:'https://assets.boardroominsiders.com/store/b8e299efc6b06aa94a31c7b9f4611c875633db171ce528991d9269b43e49',
            title:'Chairman of Northside Services, LLC and Former CEO of International Creative Management, Inc',
            BiographyP1:"Jeffrey S. Berg has been an agent in the entertainment industry for more than 40 years. Berg has served as chairman of Northside Services, LLC, a media and entertainment advisory firm, since 2015. He was chairman of Resolution, a talent and literary agency he founded, from 2013 until 2015. Between 1985 and 2012, Berg was the chairman and CEO of International Creative Management, Inc. (ICM), a talent agency for the entertainment industry. He has served as cochair of California’s Council on Information Technology and was president of the Executive Board of the College of Letters and Sciences at the University of California at Berkeley. He previously served on the Board of Trustees of the Anderson School of Management at the University of California at Los Angeles.",
            source:[
              {
                name:"Oracle",
                link:"https://www.oracle.com/sa/corporate/executives/"
              }
            ]
          },
          {
          name:'Michael J. Boskin',
          photo:'https://www.longarc.com/wp-content/uploads/2020/08/Michael-Boskin.jpg',
          title:'Professor of Economics and Hoover Institution Senior Fellow at Stanford University',
          BiographyP1:"Michael J. Boskin is the Tully M. Friedman Professor of Economics and Wohlford Family Hoover Institution Senior Fellow at Stanford University, where he has been on the faculty since 1971. He is CEO and president of consulting firm Boskin & Co., Inc. Boskin was chairman of the President’s Council of Economic Advisers from 1989 until 1993. He currently serves as a director of Bloom Energy Corporation and previously served as a director of ExxonMobil.",
          source:[
            {
              name:"Oracle",
              link:"https://www.oracle.com/sa/corporate/executives/"
            }
          ]
        },

        {
        name:'Bruce R. Chizen',
        photo:'https://images.forbes.com/media/lists/12/2007/BY3B.jpg',
        title:'Senior Adviser to Permira Advisers and Former CEO of Adobe Systems Incorporated',
        BiographyP1:"Bruce R. Chizen is currently an independent consultant and has served as senior adviser to Permira Advisers LLP since 2008 and as a venture partner at Voyager Capital since 2009. He has also served as an operating partner at private equity fund Permira Growth Opportunities since June 2018. Chizen served as a strategic adviser to Adobe Systems Incorporated, a provider of design, imaging, and publishing software for print, internet, and dynamic media production, from 2007 to 2008. From 2000 to 2007, he served as Adobe’s CEO and as its president from 2000 to 2005. He also served as Adobe’s acting CFO from 2006 to 2007; he had joined the company in 1994. Chizen also currently serves as a director of Synopsys, Inc., ChargePoint, Inc., and Informatica.",
        source:[
          {
            name:"Oracle",
            link:"https://www.oracle.com/sa/corporate/executives/"
          }
        ]
      },

      {
      name:'George H. Conrades',
      photo:'https://www.charterworld.com/news/wp-content/uploads/2013/01/George-Conrades.jpg',
      title:'Senior Advisor to and Former CEO of Akamai Technologies, Inc.',
      BiographyP1:"George H. Conrades has served as an executive advisor to Akamai Technologies, Inc., a content delivery network services provider for media and software delivery and cloud security solutions, since June 2018. He previously served as Akamai’s CEO from 1999 to 2005 and chairman from 1999 to March 2018. Conrades currently serves as a managing partner at Longfellow Venture Partners, a private venture fund advising and investing in early stage healthcare and technology companies. He also served as a venture partner at Polaris Venture Partners, an early-stage investment company, from 1998 to 2012 and is now a Partner Emeritus. He served as chairman and CEO of Akamai Technologies from 1999 to 2005. Conrades currently serves as a director of Cyclerion Therapeutics, Inc. and previously was a director of Akamai Technologies, Inc., Harley-Davidson, Inc., and Ironwood Pharmaceuticals, Inc.",
      source:[
        {
          name:"Oracle",
          link:"https://www.oracle.com/sa/corporate/executives/"
        }
      ]
      },

    {
      name:'Rona A. Fairhead',
      photo:'https://upload.wikimedia.org/wikipedia/commons/1/18/RonaFairhead.jpg',
      title:'Former Minister of State, United Kingdom Department for International Trade and Former Chair of the British Broadcasting Corporation Trust',
      BiographyP1:"Rona A. Fairhead most recently served as Minister of State for Trade and Export Promotion for the United Kingdom Department for International Trade from September 2017 to May 2019. Previously, Fairhead served as chair of the British Broadcasting Corporation Trust (BBC) from 2014 to 2017. From 2006 to 2013, she was chair and chief executive officer of the Financial Times Group Limited, which was a division of Pearson plc, and, prior to that, she served as Pearson’s chief financial officer. Before joining Pearson, Fairhead held a variety of leadership positions at Bombardier Inc. and Imperial Chemical Industries plc. Fairhead serves as a director of Electrocomponents plc. She has previously served as a director of HSBC Holdings plc and PepsiCo, Inc. She is a member of the UK House of Lords.",
      source:[
        {
          name:"Oracle",
          link:"https://www.oracle.com/sa/corporate/executives/"
        }
      ]
    },

    {
      name:'Renée J. James',
      photo:'https://media-exp1.licdn.com/dms/image/C4D03AQET3F7zKG4O9A/profile-displayphoto-shrink_200_200/0/1586532253936?e=1651104000&v=beta&t=ltKpraArYoHkzSna4dJhXePpMSJD5jocSTxkse0ftIY',
      title:'Chairman and CEO of Ampere Computing, Operating Executive at The Carlyle Group, and Former President of Intel Corporation',
      BiographyP1:"Renée J. James is currently the chairman and CEO of Ampere Computing, a company she founded in 2017, which produces high-performance semiconductors for hyperscale cloud, storage, and edge computing. James also serves as an operating executive for The Carlyle Group, a global alternative asset manager. In her role with Carlyle, James evaluates new technology investments for the firm as well as advises portfolio companies on their strategic direction and operational efficiency. In 2016, James concluded a 28-year career with Intel Corporation, where she most recently served as president. James is chair of the National Security Telecommunications Advisory Committee to the President of the United States. She also serves as a director of Citigroup Inc. She previously served as a director of Sabre Corporation and Vodafone Group Plc.",
      source:[
        {
          name:"Oracle",
          link:"https://www.oracle.com/sa/corporate/executives/"
        }
      ]
    },

    {
      name:'Charles (Wick) Moorman IV',
      photo:'https://www.fusfoundation.org/images/Moorman_Wick_11.jpg',
      title:'Senior Advisor to Amtrak and Former CEO of Amtrak and Norfolk Southern Corporation',
      BiographyP1:"Wick Moorman is currently a senior advisor to Amtrak, where he previously served as president and CEO from August 2016 until January 2018. Prior to that and until 2015, Moorman was CEO (from 2005) and chairman (from 2006) of Norfolk Southern Corporation. From 1975 to 2005, he held various positions in operations, information technology, and human resources at Norfolk Southern Corporation. Moorman serves as a director of Chevron Corporation and previously served as a director of Duke Energy Corporation and Norfolk Southern Corporation.",
        source:[
        {
          name:"Oracle",
          link:"https://www.oracle.com/sa/corporate/executives/"
        }
      ]
    },

    {
      name:'Leon E. Panetta',
      photo:'https://static01.nyt.com/images/2014/10/07/world/PANETTA/PANETTA-articleLarge.jpg?quality=75&auto=webp&disable=upscale',
      title:'Former Director of the Central Intelligence Agency and Former US Secretary of Defense',
      BiographyP1:"Leon Panetta served as United States Secretary of Defense from 2011 to 2013 and as Director of the Central Intelligence Agency from 2009 to 2011. Prior to that, Panetta was a member of the United States House of Representatives from 1977 to 1993, served as Director of the Office of Management and Budget from 1993 to 1994, and served as former President Bill Clinton’s Chief of Staff from 1994 to 1997. Panetta is the cofounder and chairman of the Panetta Institute for Public Policy and currently serves as moderator of the Leon Panetta Lecture Series, a program he created. He previously served as Distinguished Scholar to Chancellor Charles B. Reed of the California State University System and professor of public policy at Santa Clara University",
        source:[
        {
          name:"Oracle",
          link:"https://www.oracle.com/sa/corporate/executives/"
        }
      ]
    },

    {
      name:'William G. Parrett',
      photo:'https://www.nopactalent.com/upload/images/speakers/7648/267x267_Screen%20shot%202015-10-01%20at%2012.39.35%20PM.png',
      title:'Former CEO of Deloitte Touche Tohmatsu',
      BiographyP1:"William Parrett served as the chief executive officer of Deloitte Touche Tohmatsu, a multinational professional services network, from 2003 until 2007. He joined Deloitte in 1967 and served in a series of roles of increasing responsibility until his retirement in 2007. Parrett serves as a director of The Blackstone Group L.P. and Thoughtworks, Inc. He previously served as a director of the Eastman Kodak Company, Conduent Inc., Thermo Fisher Scientific, UBS Group AG, and IGATE Corporation. Parrett is a Certified Public Accountant with an active license.",
        source:[
        {
          name:"Oracle",
          link:"https://www.oracle.com/sa/corporate/executives/"
        }
      ]
    },

    {
      name:'Naomi O. Seligman',
      photo:'https://cdn.theorg.com/5fee6d32-d4c5-48fd-962b-ed31d5347e6d_small.jpg',
      title:'Senior Partner, Ostriker von Simson',
      BiographyP1:"Naomi O. Seligman is a senior partner at Ostriker von Simson, a technology research firm that chairs the CIO Strategy Exchange. Since 1999, this forum has brought together senior executives in four vital quadrants of the IT sector. From 1977 until 1999, Seligman served as a cofounder and senior partner of Research Board, Inc., a private-sector institution sponsored by 100 chief information officers from major global corporations. She previously served as a director of Akamai Technologies, Inc., IGATE Corporation, and Dun & Bradstreet.",
        source:[
        {
          name:"Oracle",
          link:"https://www.oracle.com/sa/corporate/executives/"
        }
      ]
    },

    {
      name:'Vishal Sikka',
      photo:'https://images.itnewsinfo.com/lmi/articles/grande/000000058237.jpg',
      title:'Founder and CEO of Vianai Systems, Inc.',
      BiographyP1:"Vishal Sikka is the founder and CEO of Vianai Systems, Inc., a startup company that provides advanced software and services in artificial intelligence and machine learning. Previously, he was the CEO and Managing Director of Infosys Limited, a multinational IT services company, from 2014 to 2017. From 2002 to 2014, Sikka was at SAP SE, a multinational software company, where he served on the Executive Board from 2010 to 2014. He serves on the Supervisory Board of BMW Group and on the Advisory Council for the Stanford Institute for Human-Centered Artificial Intelligence. Sikka holds a PhD in computer science with a focus on artificial intelligence from Stanford University.",
        source:[
        {
          name:"Oracle",
          link:"https://www.oracle.com/sa/corporate/executives/"
        }
      ]
    },



        ]
      }


    ],


  },
  {
    companyName:"Hippo Education",
    companyHeadOfficeLocation:"California | Los Angeles, CA",
    companyLevel1:[
      {
        name:"Hippo Education Executive Leadership",
        people:[

          {
            name:'Aaron Bright',
            photo:'https://media-exp1.licdn.com/dms/image/C4D03AQGLXOUdI9y7DQ/profile-displayphoto-shrink_200_200/0/1516301683872?e=1655942400&v=beta&t=06bluJJSV2uutVbrvCGuge8EUJRKsV57zDWW96paDq0',
            title:'Founder & CEO,Executive,Management, Operations',
            BiographyP1:'',
            source:[
              {
                name:"crunchbase",
                link:"https://www.crunchbase.com/organization/hippo-education/people"
              }
            ],
            report1:[
              {
                name:'Gavin Chan ',
                photo:'https://media-exp1.licdn.com/dms/image/C5103AQEKEoOm1nc9kQ/profile-displayphoto-shrink_200_200/0/1516252728305?e=1655942400&v=beta&t=MnW3lyxOG1vP2n34I90D0sLLgB-h4EQiWLISjNroz8g',
                title:'COO at Hippo Education',
                BiographyP1:"",
                source:[
                  {
                    name:"theorg",
                    link:"https://theorg.com/org/oracle/org-chart/joyce-westerdahl"
                  }
                ],
                report2:[

                  {
                    name:'Amanda Finkelberg',
                    photo:'https://media-exp1.licdn.com/dms/image/C5603AQHBxw8rVys7Ag/profile-displayphoto-shrink_200_200/0/1611335270656?e=1655942400&v=beta&t=rgovNzUjOlQZ6UmPMBkmo_Z_5jDsy6ZUhHzTMno2nF8',
                    title:'Vice President of Product at Hippo Education',
                    BiographyP1:'No BiographyP1',
                    source:[
                      {
                        name:"linkedIn",
                        link:"https://www.linkedin.com/in/amandafinkelberg/"
                      }
                    ],
                    // report3:[
                    //   {
                    //     name:'Claire Bennett',
                    //     photo:'https://cdn.theorg.com/6ab278e8-00fa-4b34-b2f4-2910cfd86211_medium.jpg',
                    //     title:'VP, HR - EMEA',
                    //     phoneNumber:'',
                    //     email:"",
                    //     website:"",
                    //     address:"United Kingdom",
                    //     linkedIn:"linkedin.com/in/claire-bennett-461478",
                    //     Education:[
                    //       {
                    //
                    //         year:"2002 - 2003",
                    //         certificateName:"MSC, Human Resources ManagementMSC, Human Resources Management",
                    //         certificatePoints:"Distinction",
                    //         institutionName:"University of Portsmouth",
                    //       },
                    //       {
                    //         year:"1996 - 1998",
                    //         certificateName:"IPD Qualification",
                    //         certificatePoints:"unknown points",
                    //         institutionName:"University of Portsmouth",
                    //       },
                    //       {
                    //         year:"1991 - 1994",
                    //         certificateName:"BSC - English & Classics",
                    //         certificatePoints:"unknown points",
                    //         institutionName:"Keele University",
                    //       },
                    //
                    //
                    //
                    //     ],
                    //     languages:[
                    //       {
                    //         languageName:"English",
                    //         languagesPercent:"95%"
                    //       }
                    //     ],
                    //     BiographyP1:'Executive level HR Professional with extensive International knowledge & Overseas experience. Results driven & able to respond to complex and challenging business situations with complimentary HR strategies',
                    //     BiographyP2:"Specialties: HR Strategy, HR Business Partnering, Organisation Design, Business Transformation, Global Project & Programme Management, Leadership, Consultancy, Trusted Advisor",
                    //     BiographyP3:"",
                    //     BiographyP4:"",
                    //     BiographyP5:"",
                    //     Experience:[
                    //       {
                    //         yearsOfExperience:"Dec 2017 - Present 2022",
                    //         placeOfExperience:"Oracle",
                    //         locationOfExperience:"location unknown!!!",
                    //         areaOfExpertise:"Vice President, EMEA Human Resources",
                    //         descOfWorkDoneInAreaOfExpertise:"HR Leader, focused on providing strategic HR Partnering to Executive Vice President Applications, EMEA & JAPAC. Focused on Optimising Business Performance, Executive Leadership, Organisation Design and Transformation. Responsible for leading a team of Senior HRBPs who align with EMEA based Executives (Senior Vice Presidents / Vice Presidents) within the License Organisation,",
                    //       },
                    //       {
                    //         yearsOfExperience:"Apr 2015 - Present 2022",
                    //         placeOfExperience:"Oracle",
                    //         locationOfExperience:"United Kingdom",
                    //         areaOfExpertise:"Senior Director, Human Resources, EMEA",
                    //         descOfWorkDoneInAreaOfExpertise:"- Determination of strategic HR direction for Oracle Applications Business across all EMEA countries, including Cloud transformation across all SaaS product lines - Leadership responsibility for a team of Snr HR Business Partners, supporting multiple License Sales Organisations (inc. Apps, Tech, Alliances & Channels) across EMEA countries - Trusted Advisor & Exec level engagement with Oracle EMEA Senior Vice Presidents - Experienced in managing complex Change Management activities, Organisation Design, Business Transformation, Sales Compensation, Consultation, Workforce Planning, Exec Talent Management - Skilled in integrating Acquired Companies into both new & existing Lines of Business",
                    //       },
                    //
                    //       {
                    //         yearsOfExperience:"Mar 2010 - May 2013",
                    //         placeOfExperience:"Oracle",
                    //         locationOfExperience:"location unknown",
                    //         areaOfExpertise:" Senior HR Business Partner, EMEA",
                    //         descOfWorkDoneInAreaOfExpertise:"Partnering with SVP's & Executive Leadership teams to deliver strategic HR initiatives across Western Europe Applications Responsible for organisation design, change management, business transformation, executive coaching, strategic projects, restructuring across EMEA region Global Project Leadership : Employee Insight Survey, HR Analytics",
                    //       },
                    //       {
                    //         yearsOfExperience:"1994 - 1998",
                    //         placeOfExperience:"Southern Water",
                    //         locationOfExperience:"location unknown",
                    //         areaOfExpertise:"Senior HR Officer",
                    //         descOfWorkDoneInAreaOfExpertise:"",
                    //       },
                    //       {
                    //         yearsOfExperience:"1998 - 2000",
                    //         placeOfExperience:"Scottish Power",
                    //         locationOfExperience:"location unknown",
                    //         areaOfExpertise:"HR Manager ",
                    //         descOfWorkDoneInAreaOfExpertise:"HR responsibility for 400 employees on multiple sites within the Engineering &amp; Technical Division",
                    //       },
                    //       {
                    //         yearsOfExperience:"May 2013 - Apr 2015",
                    //         placeOfExperience:"Oracle",
                    //         locationOfExperience:"location unknown",
                    //         areaOfExpertise:"Director, Human Resources, EMEA",
                    //         descOfWorkDoneInAreaOfExpertise:"Leadership responsibility for a team of Snr HR Business Partners, supporting Oracle's License Sales Organisation Executive level engagement & provision of strategic HRBP support across multiple lines of business Results oriented, focusing on strong collaboration & engagement with stakeholders Interested in process & programme transformation to improve delivery & reduce complexity",
                    //       },
                    //       {
                    //         yearsOfExperience:"May 2007 - Mar 2010",
                    //         placeOfExperience:"Sun Microsystems",
                    //         locationOfExperience:"location unknown",
                    //         areaOfExpertise:"Global HR Operations & Programme Manager",
                    //         descOfWorkDoneInAreaOfExpertise:"Member of HR Leadership team, focused on driving functional operational efficiencies and global standardisation of programme design, implementation & delivery across 52 countries Budget responsibility for HR spend, including Sun's global outsourced Shared Services contract HR Leader of Reduction in Force programme across International countries Formation of HR business plan & strategic organisational objectives Member of Shared Services project team, including developing next generation HR Systems & Service Delivery Completion of career development assignment; leadership responsibility for 6 country HR teams across Latin America",
                    //       },
                    //
                    //       {
                    //         yearsOfExperience:"2006 -  2007",
                    //         placeOfExperience:"Sun Microsystems",
                    //         locationOfExperience:"location unknown",
                    //         areaOfExpertise:"Senior HR Manager; Service Delivery Project Manger",
                    //         descOfWorkDoneInAreaOfExpertise:"Member of Management team responsible for the implementation of HR BPO project with Hewitt Associates across EMEA countries Partnered with outsourced provider to jointly manage the operational set up of the Regional Service Centre in Krakow Development of change management and change acceptance techniques for stakeholders",
                    //       },
                    //       {
                    //         yearsOfExperience:"Apr 2004 - May 2006",
                    //         placeOfExperience:"Sun Microsystems",
                    //         locationOfExperience:"location unknown",
                    //         areaOfExpertise:"Head of HR, Asia SouthHead of HR, Asia South",
                    //         descOfWorkDoneInAreaOfExpertise:"Assignment to Singapore to manage the HR function across Asia South countries Member of Asia South Leadership team, providing strategic HR Business Partnering to executives &amp; directors; Change Management, HR strategy, Succession planning, Coaching Leader of HR Shared Services function responsible for; Mergers &amp; Acquisitions, Outsourcing, Employee Relations, Workforce planning,Country HR representative for media &amp; government enquiries Re-design of flexible benefits programme",
                    //       },
                    //
                    //       {
                    //         yearsOfExperience:"Oct 2000 - Apr 2004",
                    //         placeOfExperience:"Sun Microsystems",
                    //         locationOfExperience:"location unknown",
                    //         areaOfExpertise:"HR Business Partner, Global Sales, UKHR Business Partner, Global Sales, UK",
                    //         descOfWorkDoneInAreaOfExpertise:"Worked with UK Vice President &amp; Global Sales Directors to ensure HR responds to business priorities, adds value &amp; delivers appropriate solutions Focused on Talent management, Organisational competitiveness, Performance Management, Employee Relations",
                    //       },
                    //
                    //
                    //
                    //     ],
                    //     professionalSkills:[
                    //       {
                    //
                    //         nameOfSkill:"Strategy",
                    //         persentageOfSkills:"95%",
                    //       },
                    //       {
                    //         nameOfSkill:"Human Resources",
                    //         persentageOfSkills:"95%",
                    //       },
                    //       {
                    //         nameOfSkill:"Talent Management",
                    //         persentageOfSkills:"95%",
                    //       },
                    //       {
                    //         nameOfSkill:"Change Management",
                    //         persentageOfSkills:"95%",
                    //       },
                    //       {
                    //         nameOfSkill:"Outsourcing",
                    //         persentageOfSkills:"95%",
                    //       },
                    //       {
                    //         nameOfSkill:"Performance Management",
                    //         persentageOfSkills:"95%",
                    //       },
                    //       {
                    //         nameOfSkill:"Employee Relations",
                    //         persentageOfSkills:"95%",
                    //       },
                    //       {
                    //         nameOfSkill:"HR Policies",
                    //         persentageOfSkills:"95%",
                    //       },
                    //       {
                    //         nameOfSkill:"Shared Services",
                    //         persentageOfSkills:"95%",
                    //       },
                    //       {
                    //         nameOfSkill:"Training",
                    //         persentageOfSkills:"95%",
                    //       },
                    //       {
                    //         nameOfSkill:"Succession Planning",
                    //         persentageOfSkills:"95%",
                    //       },
                    //
                    //     ],
                    //     Interest:[
                    //       {
                    //         // iconOfInterest:"",
                    //         // nameOfInterest:"",
                    //       }
                    //     ],
                    //     source:[
                    //       {
                    //         name:"Oracle",
                    //         link:"https://www.oracle.com/sa/corporate/executives/"
                    //       },
                    //
                    //       {
                    //         name:"contactout.com",
                    //         link:"https://contactout.com/Claire-Bennett-607265"
                    //       },
                    //
                    //       {
                    //         name:"linkedin.com",
                    //         link:"https://www.linkedin.com/in/claire-bennett-461478/"
                    //       },
                    //
                    //     ]
                    //   },
                    // ]
                  },
                ],
              },


              {
                name:'Amanda Finkelberg',
                photo:'https://res.cloudinary.com/crunchbase-production/image/upload/c_lpad,h_256,w_256,f_auto,q_auto:eco,dpr_1/ao5szycnxpp6lqqsxmnr',
                title:'Vice President of Product,VP Operations',
                BiographyP1:'',
                source:[
                  {
                    name:"crunchbase",
                    link:"https://www.crunchbase.com/organization/hippo-education/people"
                  }
                ]
              },
              {
                name:'Rob Taves',
                photo:'https://media-exp1.licdn.com/dms/image/C5603AQFQMZTq_JCgYA/profile-displayphoto-shrink_200_200/0/1595971896857?e=1655942400&v=beta&t=kn9pLOMie-UFCR8UwzKDRfWPNvL5rkG_UwT-u5okrU4',
                title:'Director of Engineering VP Engineering, Management',
                BiographyP1:'',
                source:[
                  {
                    name:"linkedIn",
                    link:"https://www.linkedin.com/company/hippo-education-inc-/people/"
                  }
                ],
                report2:[
                  {
                    name:'Unknown',
                    photo:'https://media-exp1.licdn.com/dms/image/C4D03AQFyPU66qzZhnQ/profile-displayphoto-shrink_200_200/0/1623933587259?e=1655942400&v=beta&t=wYMIC0W0fz4cKSDPaw5QhqkUM_1BIxNhisT80Y-LBkQ',
                    title:'Audio Engineer at Periscope Post and Audio',
                    BiographyP1:'No BiographyP1',
                    source:[
                      {
                        name:"linkedIn",
                        link:"https://www.linkedin.com/company/hippo-education-inc-/people/"
                      }
                    ],
                  },
                  {
                    name:"Adam Carl",
                    photo:'https://media-exp1.licdn.com/dms/image/C5603AQG9TTaPdfFKXw/profile-displayphoto-shrink_200_200/0/1560014247529?e=1655942400&v=beta&t=RE_vlw914fMIKftXn0_6ofAALpCgbLksnLnlxTJ_wxA',
                    title:'Audio Engineer - Sound Designer - Producer',
                    BiographyP1:'No BiographyP1',
                    source:[
                      {
                        name:"linkedIn",
                        link:"https://www.linkedin.com/company/hippo-education-inc-/people/"
                      }
                    ],
                  },

                  {
                    name:"Brittany (Heller) Ellich",
                    photo:'https://media-exp1.licdn.com/dms/image/C5603AQEpoiUSDnQW_w/profile-displayphoto-shrink_200_200/0/1540415411091?e=1655942400&v=beta&t=C1sQs6Fdw5k6TlE2uUlkEgV5xJI2kiso8a20z1B11Zk',
                    title:'Senior Software Developer at Hippo Education',
                    BiographyP1:'Full-stack software engineer with an aptitude for innovation and creative problem solving. Backend experience in C#, Java, and Node, front end experience in React, and cloud experience in AWS, but open to new technologies. I enjoy designing, developing, and implementing solutions to meet customer needs. When not at work I spend time developing side projects and learning new technologies in order to advance my skillset, as well as organizing and attending software-focused meetups to contribute back to my community.',
                    source:[
                      {
                        name:"linkedIn",
                        link:"https://www.linkedin.com/company/hippo-education-inc-/people/"
                      }
                    ],
                    report3:[
                      {
                        name:"Hannah Yockel ",
                        photo:'https://media-exp1.licdn.com/dms/image/C4D03AQG7MI92VmFU6w/profile-displayphoto-shrink_200_200/0/1648742958739?e=1655942400&v=beta&t=N-cwNzVx33N6TZ20QPwNyuBZe2lLa7dBpI7d-jI11QU',
                        title:'Software Developer',
                        BiographyP1:'No BiographyP1',
                        source:[
                          {
                            name:"linkedIn",
                            link:"https://www.linkedin.com/company/hippo-education-inc-/people/"
                          }
                        ],
                      },

                    ],
                  }
                ],
              },



            ]
          },


        ]
      },

      {
        name:"Hippo Education Board of Directors",
        people:[
          {
            name:'Unknown',
            photo:'unknown',
            title:'unknown',
            BiographyP1:'unknown',
            source:[
              {
                name:"unknown",
                link:"unknown"
              }
            ]
          },




        ]
      }


    ],

  },
  {
    companyName:"Red Acre",
    companyHeadOfficeLocation:"Valletta, Malta. Time zone in Malta (GMT+2)",
    companyLevel1:[
      {
        name:"Red Acre Executive Leadership",
        people:[


          {
            name:'Shane Morton',
            photo:'https://media-exp1.licdn.com/dms/image/C4D03AQGkqLwk0OD4Ug/profile-displayphoto-shrink_200_200/0/1594113508686?e=1658361600&v=beta&t=VygdggQNq4DpNVU8TRwMG5T-94Aqd-z6rWq1ja19aFI',
            title:'Chief Executive Officer',
            BiographyP1:'',
            source:[
              {
                name:"linkedin",
                link:"https://www.linkedin.com/in/shane-morton-56a613179/?original_referer=https%3A%2F%2Fwww%2Egoogle%2Ecom%2F&originalSubdomain=mt"
              }
            ],
            report1:[
              {
                name:'Whitney Sciberras ',
                photo:'https://media-exp1.licdn.com/dms/image/C4D03AQH9jwuCrwBI_w/profile-displayphoto-shrink_200_200/0/1641580951272?e=1658361600&v=beta&t=0CZFe_Vi3_RrSlFwNRnc-cmU6kegc8I7s7FnAvimmlg',
                title:'Human Resources Coordinator at Red Acre Ltd.',
                BiographyP1:"",
                source:[
                  {
                    name:"linkedin",
                    link:"https://www.linkedin.com/in/whitney-sciberras-a1319834/"
                  }
                ],
                report2:[
                  {
                    name:'Serena R. Lacerenza',
                    photo:'https://media-exp1.licdn.com/dms/image/C4E03AQEDGl5sP9VAFg/profile-displayphoto-shrink_200_200/0/1626518174029?e=1658361600&v=beta&t=viA4X2RobOHvt1T10JKIhq3e2UjX5e72xIiM29KKvfI',
                    title:'Talent Acquisition - Information Technology | Digital Marketing |',
                    BiographyP1:"Experienced Talent Acquisition Specialist with a demonstrated history of working in the information technology and digital marketing industries, with a solid understanding of the iGaming, Information Technology, Marketing, Legal, Banking, Finance, FinTech, Forex, and Crypto industries. ",
                    BiographyP2:"Able to work on multiple searches at the same time, while understanding priorities; to communicate with hiring managers from different departments, understanding their requirements, advising and supporting them throughout the whole recruitment process. ",
                    BiographyP3:"Skilled in employees onboarding and offboarding processes.",
                    BiographyP4:"Loves Photograhs and nature (instagram)",
                    phoneNumber:'',
                    email:"careers@redacreltd.freshteam.com | serena@bettingconections.com",
                    website:"redacreltd.com/  (Company Website)",
                    twitter:"https://twitter.com/serenarl",
                    address:"San Pawl il-Baħar | Malta (facebook)",
                    linkedIn:"https://www.linkedin.com/in/serena-r-lacerenza-51b53928/?originalSubdomain=mt",
                    Education:[
                      {
                        year:"2010 - 2011",
                        institutionName:"Free International University Of Social Studies",
                        certificateName:"Masters (Human Resources)",
                        certificatePoints:"",
                      },
                      {
                        year:"2007 - 2010",
                        institutionName:"University of Bari",
                        certificateName:"Masters (Philosophy)",
                        certificatePoints:"",
                      }
                      ,
                      {
                        year:"2003 - 2007",
                        institutionName:"University of Bari",
                        certificateName:"Bachelors (Philosophy)",
                        certificatePoints:"",
                      }
                      ,
                      {
                        year:"1998 - 2003",
                        institutionName:"Liceo Classico \"Alfredo Casardi\"",
                        certificateName:"(Business)",
                        certificatePoints:"",
                      }
                    ],
                    languages:[
                    {
                      languageName:"Italian. Native or bilingual proficiency",
                      languagesPercent:"95%"
                    },
                    {
                      languageName:"English Professional working proficiency",
                      languagesPercent:"95%"
                    },
                  ],
                    Experience:[
                      {
                        yearsOfExperience:"May 2021 - Present",
                        placeOfExperience:"Red Acre Ltd · Full-time",
                        locationOfExperience:"Sliema, Malta",
                        areaOfExpertise:"Talent Acquisition",
                        descOfWorkDoneInAreaOfExpertise:"Red Acre Ltd. is a global organization and SaaS company that provides services to FinTech companies, predominantly within the Forex and Crypto industries.I am responsible for recruiting in Malta, Dublin and Limassol-based offices. 1=>Manage the full recruitment life cycle (technology, digital marketing, finance and legal departments). 2=>Communicate with the hiring managers and support them throughout the whole recruitment process. 3=>Headhunting in the EMEA and LATAM markets 4=>Employer branding 5=>Onboarding and Offboarding 6=>Conduct skip-level meetings for the marketing, finance, trade and administration departments. 6=>Schedule and follow up on performance assessment meetings. ",
                      },
                      {
                        yearsOfExperience:"Jan 2019 - May 2021",
                        placeOfExperience:"Archer - The IT Recruitment Consultancy",
                        locationOfExperience:"Xbiex, Malta",
                        areaOfExpertise:"Associate Recruitment Manager",
                        descOfWorkDoneInAreaOfExpertise:"Archer is a Dublin and Malta-based IT recruitment agency. I joined the company when it was a startup and developed my role together with the company’s growth. 1==>Hands-on recruitment of IT professionals in the EMEA space. ==>Business Development – look for new business opportunities and negotiate terms and conditions. 3==>Account Management – manage a large portfolio of clients in order to deliver high standards and to improve the business relationships.4==>Internal Recruitment 5==> Training and coaching junior recruiters 6==> Team performance assessment and KPIs management 7==>Keeping records of the weekly and monthly report 8==>Attending board meetings 9==> Report to the Managing Director based in Dublin. ",
                      },
                      {
                        yearsOfExperience:"Jan 2017 - Dec 2018",
                        placeOfExperience:"Archer - The IT Recruitment Consultancy",
                        locationOfExperience:"Malta",
                        areaOfExpertise:"Lead Consultant",
                        descOfWorkDoneInAreaOfExpertise:"Responsible for growing and managing the Malta based office. Successfully grew the team, achieved team targets, and managed a team of 6-8 people. •	360 consultant (business development, account management and recruitment)•	Internal recruitment•	Team leading•	KPIs management•	Keeping records of the weekly and monthly report•	Report to the Managing Director based in Dublin",
                      },
                      {
                        yearsOfExperience:"Sep 2016 - Dec 2016",
                        placeOfExperience:"Archer - The IT Recruitment Consultancy",
                        locationOfExperience:"Sliema, Malta",
                        areaOfExpertise:"Senior IT Recruitment Consultant | IT Infrastructure | DevOps",
                        descOfWorkDoneInAreaOfExpertise:"•	Business development, account management and recruitment.",
                      },
                      {
                        yearsOfExperience:"May 2012 - Feb 2015",
                        placeOfExperience:"Betting Connections",
                        locationOfExperience:"Sliema, Malta",
                        areaOfExpertise:"Recruitment Consultant",
                        descOfWorkDoneInAreaOfExpertise:"Betting Connections is a Malta-based recruitment agency that specializes in the iGaming market. •	Responsible for recruiting internationally Marketing, IT, Sales, Finance and Customer Service professionals within the iGaming industry.",
                      },
                      {
                        yearsOfExperience:"Jun 2011 - Oct 2011",
                        placeOfExperience:"Gi Group",
                        locationOfExperience:"Rome, Italy",
                        areaOfExpertise:"Recruitment & HR Administration Assistant - Internship",
                        descOfWorkDoneInAreaOfExpertise:"Gi Group is an international Interim Recruitment Agency. =>•	Recruit professionals within the hospitality and retail industries.==>•	Support the payroll department.",
                      },
                    ],
                    professionalSkills:[
                      {

                        nameOfSkill:"",
                        persentageOfSkills:"",
                      },


                    ],
                    Interest:[
                      {
                        // iconOfInterest:"",
                        // nameOfInterest:"",
                      }
                    ],
                    source:[
                      {
                        name:"linkedin",
                        link:"https://www.linkedin.com/in/serena-r-lacerenza-51b53928/?originalSubdomain=mt"
                      },
                      {
                        name:"instagram",
                        link:"https://www.instagram.com/_blackeyes_92/?hl=en"
                      },
                      {
                        name:"facebook",
                        link:"https://web.facebook.com/serena.r.lacerenza/about?lst=100006607650013%3A1301445150%3A1653147888&_rdc=1&_rdr"
                      }
                    ],


                  },
                ],

              },

              {
                name:'Ian Tabone',
                photo:'https://media-exp1.licdn.com/dms/image/C4D03AQFotaTaeAmNOw/profile-displayphoto-shrink_200_200/0/1568407161717?e=1658361600&v=beta&t=NlZZ4bbOwRzj7P2tJFm81r3S04gKvSpX5yGAr0oUWmE',
                title:'Head of Technology at Red Acre Ltd',
                BiographyP1:"",
                source:[
                  {
                    name:"linkedin",
                    link:"https://www.linkedin.com/company/red-acre-ltd/people/"
                  }
                ],
                report2:[
                  {
                    name:'Burak KÖSE',
                    photo:'https://media-exp1.licdn.com/dms/image/C5603AQGclk5ies-Xtg/profile-displayphoto-shrink_200_200/0/1566082547390?e=1658361600&v=beta&t=Mo606GPv1dEwt-gZMBd5gQkqDC24TWZ24mbHx8cMcRw',
                    title:'Senior DevOps Engineer at Red Acre Ltd',
                    BiographyP1:"",
                    source:[
                      {
                        name:"linkedin",
                        link:"https://www.linkedin.com/company/red-acre-ltd/people/"
                      }
                    ],

                  },


                  {
                    name:'Derli Campos',
                    photo:'https://media-exp1.licdn.com/dms/image/C4D03AQECyHHea9pp9Q/profile-displayphoto-shrink_200_200/0/1592571338731?e=1658361600&v=beta&t=sqXG0WuOFqqGhcUbuH1602fMj6ZbDtt7sgjKCGsF5oI',
                    title:'Senior Systems Administrator',
                    BiographyP1:'',
                    source:[
                      {
                        name:"linkedin",
                        link:"https://www.linkedin.com/company/red-acre-ltd/people/"
                      }
                    ]
                  },
                  {
                    name:'!!!Unknown!!!',
                    photo:'https://media-exp1.licdn.com/dms/image/C4D03AQEG2RkkLUE8SQ/profile-displayphoto-shrink_200_200/0/1571083183902?e=1658361600&v=beta&t=zfh4-ZkGkcmJe-Nn6mudSNqc8kWzdNK5u5k11fPqRPA',
                    title:'Senior Software Developer',
                    BiographyP1:'',
                    source:[
                      {
                        name:"linkedin",
                        link:"https://www.linkedin.com/company/red-acre-ltd/people/"
                      }
                    ],
                    report3:[
                      {
                        name:'Emmanuel Odongo',
                        photo:'https://media-exp1.licdn.com/dms/image/C4E03AQHY8m9NF6krIQ/profile-displayphoto-shrink_200_200/0/1608407608106?e=1658361600&v=beta&t=k8inM7gD-gOkKrgL_RACUERHZC4s17RhTEp8un-DsLI',
                        title:'Full Stack Developer at Red Acre Ltd',

                        phoneNumber:'',
                        email:"",
                        website:"",
                        address:"",
                        linkedIn:"",
                        BiographyP1:'No BiographyP1',
                        Experience:[
                          {
                            yearsOfExperience:"",
                            placeOfExperience:"",
                            locationOfExperience:"",
                            areaOfExpertise:"",
                            descOfWorkDoneInAreaOfExpertise:"",
                          },
                        ],
                        professionalSkills:[
                          {

                            nameOfSkill:"",
                            persentageOfSkills:"",
                          },


                        ],
                        Interest:[
                          {
                            // iconOfInterest:"",
                            // nameOfInterest:"",
                          }
                        ],

                        source:[
                          {
                            name:"linkedin",
                            link:"https://www.linkedin.com/in/emmanuelodongo/"
                          }
                        ],
                        Education:[
                          {

                            year:"",
                            certificateName:"",
                            certificatePoints:"",
                            institutionName:"",
                          },


                        ],
                        languages:[
                          {
                            languageName:"",
                            languagesPercent:""
                          }
                        ],


                      },
                    ]

                  },


                ]

              },



            ]
          },


        ]
      },

      {
        name:"Red Acre Board of Directors",
        people:[

        ]
      }


    ],


  },
  {
    companyName:"proxify",
    companyHeadOfficeLocation:"Headquartered in Stockholm, Uppland, Sweden  GMT(+2)",
    companyLevel1:[
      {
        name:"proxify Executive Leadership",
        people:[


          {
            name:'Viktor Jarnheimer',
            photo:'https://career.proxify.io/_nuxt/img/0d5939d.webp',
            title:'Co-founder and CEO',
            BiographyP1:'A full-stack developer who has run four startups before Proxify - all with a focus on cutting edge technologies, built using distributed teams.',
            source:[
              {
                name:"proxify",
                link:"https://career.proxify.io/company/"
              }
            ],
            report1:[
              {
                name:'Nadia Pokhyla',
                photo:'https://career.proxify.io/_nuxt/img/0716184.webp',
                title:'Head of Recruitment',
                BiographyP1:"An experienced and results-oriented recruiter, with a strong background in global IT recruitment, highly focused on creating the perfect match between great companies and IT professionals.",
                source:[
                  {
                    name:"proxify",
                    link:"https://career.proxify.io/company/"
                  }
                ],
                report2:[
                  {
                    name:'Alexis Komarov',
                    photo:'https://career.proxify.io/_nuxt/img/56793c4.webp',
                    title:'Head of Talent Acquisition',
                    phoneNumber:'',
                    email:"",
                    website:"",
                    twitter:"",
                    address:"",
                    linkedIn:"",
                    Education:[
                      {
                        year:"",
                        institutionName:"",
                        certificateName:"",
                        certificatePoints:"",
                      },

                    ],
                    languages:[
                    {
                      languageName:"English",
                      languagesPercent:"95%"
                    },
                    {
                      languageName:"English Professional working proficiency",
                      languagesPercent:"95%"
                    },
                  ],
                    Experience:[
                      {
                        yearsOfExperience:"",
                        placeOfExperience:"",
                        locationOfExperience:"",
                        areaOfExpertise:"",
                        descOfWorkDoneInAreaOfExpertise:"",
                      },

                    ],
                    professionalSkills:[
                      {

                        nameOfSkill:"",
                        persentageOfSkills:"",
                      },


                    ],
                    Interest:[
                      {
                        // iconOfInterest:"",
                        // nameOfInterest:"",
                      }
                    ],
                    source:[
                      {
                        name:"",
                        link:""
                      },

                    ],

                    report3:[
                      {
                        name:'Christina Kobets /Khrystyna Kobets',
                        photo:'https://proxify.io/_nuxt/img/dee14f5.webp',
                        title:'Talent Acquisition',
                        phoneNumber:'',
                        email:"",
                        website:"",
                        twitter:"",
                        address:"",
                        linkedIn:"",
                        Education:[
                          {
                            year:"",
                            institutionName:"",
                            certificateName:"",
                            certificatePoints:"",
                          },

                        ],
                        languages:[
                        {
                          languageName:"English",
                          languagesPercent:"95%"
                        },
                        {
                          languageName:"English Professional working proficiency",
                          languagesPercent:"95%"
                        },
                      ],
                        Experience:[
                          {
                            yearsOfExperience:"Dec 2020 - Present",
                            placeOfExperience:"Proxify",
                            locationOfExperience:"Kyiv, Kyiv City, Ukraine",
                            areaOfExpertise:"Talent Acquisition Specialist",
                            descOfWorkDoneInAreaOfExpertise:"Working with different technical and non-technical roles (full recruitment cycle - detecting needs, building the plan, sourcing, outreach, interviewing, leading through the process, presenting offers); ===>Working with inbound and outbound pipelines on different markets; ==>Scheduling interviews, arranging on-sites, meeting with candidates; ===>Helping in building the recruitment process within the Company.",
                          },

                        ],
                        professionalSkills:[
                          {

                            nameOfSkill:"",
                            persentageOfSkills:"",
                          },


                        ],
                        Interest:[
                          {
                            // iconOfInterest:"",
                            // nameOfInterest:"",
                          }
                        ],
                        source:[
                          {
                            name:"",
                            link:""
                          },

                        ],


                      },
                    ],


                  },
                ],

              },





            ]
          },


        ]
      },

      {
        name:"proxify Board of Directors",
        people:[

        ]
      }


    ],


  },

  {
    companyName:"camsol",
    companyHeadOfficeLocation:"Headquartered in Stockholm, Uppland, Sweden  GMT(+2)",
    companyLevel1:[
      {
        name:"CAMSOL GERMANY",
        people:[ 
          
          {
            name:"Friends",
            photo:camsol_logo1,
            report1:[
              {
                name:"Bylle Bauer"
              },
              {
                name:"Daniel Antoni"
              },
              {
                name:"Patrick Mitlacher"
              },
              {
                name:"Andreas Rätzel"
              },
              {
                name:"Frederick Hofmann"
              },
              {
                name:"Tobias Braun"
              },
              
            ]
          },
          {
            name:"Operations & Technologies",
            photo:camsol_logo1,
            report1:[
              {
                name:'Tobias Braun',
                photo:cms4_Tobi,
                title:'CTO and CHRO',
                report2:[
                  {
                    name:'Mafany Tande Myles Bilong',
                    photo:"cms2_max",
                    title:'PA',
                    BiographyP1:'ask him ?????????????????? or find out form slack',
                    sickLeaveDayNumber:"1",
                    sickLeaveExplain:[
                      {reason:"Good day sir Mohamad. Hope you're well.I caught chicken pox for the first time in my life and it's not looking pretty. I don't want the confinement of hospitals so I just skipped all that and went to get the medicine myself.I went to a pharmacy earlier to have some meds bought. I'm writing to inquire if there's support for that, although I didn't go through the normal procedure of consultation.",
                        date:"10-06-2024",
                        paid:"yes",
                        amount:"18420",
                        paidDate:"10-06-2024",
                        supportingDocs:[
                          {doc:myles_1},
                        ]
                        
                      },

                    ]
                  },
                  {
                    name:"Product & Design",
                    photo:camsol_logo1,
                    report3:[
                      {
                        name:'Leonardo Bornhäußer',
                        photo:cms11_leo,
                        title:'Ask him ???????????????',
                        BiographyP1:'ask him ?????????????????? or find out form slack',
                        source:[
                          {
                            name:"unknown???????",
                            link:"??????"
                          }
                        ],
                        report4:[
                          {name:"Design",
                            photo:camsol_logo1,
                            report5:[
                              {name:"Design Team 1",
                            photo:camsol_logo1,
                              report6:[
                                {
                                  name:'Alane Johan',
                                  photo:cms19_johanah,
                                  title:'',
                                  report7:[
                                    {
                                      name:'Ngumih Fien Mbimsi-mbom',
                                      photo:"",
                                      title:'',
                                      layoff:true
                                    },
                                    {
                                      name:'Djiabi Angoh Maggy Ange',
                                      layoff:true,
                                      photo:'https://ca.slack-edge.com/T03MZB4ML81-U0455K411LZ-8575ba402a86-512',
                                      title:'',
                                    },
                                    {
                                      name:'Kapgang Djampou Ralph Landry',
                                      photo:"https://ca.slack-edge.com/T03MZB4ML81-U03V1R20771-9d5b6742a665-512",
                                      title:'',
                                      layoff:true
                                    },
                                    {
                                      name:'Nahjela Roselyn Bassah',
                                      photo:'https://ca.slack-edge.com/T03MZB4ML81-U048YGM7684-6d166bd46f85-512',
                                      title:'',
                                    },
                                    
                                  ]
                                },
                              ]
                          },
                          {name:"Design Team 2",
                            photo:camsol_logo1,
                              report6:[
                                 {
                                name:'Nkamibo Delor',
                                photo:cms12_Delor,
                                title:'',
                                report7:[
                                  
                                  {
                                    name:'Nwoteh Magung Issabel',
                                    photo:'https://ca.slack-edge.com/T03MZB4ML81-U03NH8K3U15-e1fe47757c7e-512',
                                    title:'',
                                  },
                                  {
                                    name:'Foncham Bernard Bassah',
                                    photo:"https://ca.slack-edge.com/T03MZB4ML81-U051GPZQCR2-08ef616735f2-512",
                                    title:'',
                                  },
                                  {
                                    name:'Francis Berinyuy',
                                    photo:cms22_francesBeri,
                                    title:'',
                                  },
                                ]
                              },
                              ]
                          },
                             
                            ]
                          },

                          {name:"Social Media",
                          photo:camsol_logo1,
                          report5:[
                            {
                              name:'Stephanie Wainachi',
                              photo:cms14_steph,
                              title:'',
                              report6:[
                                {
                                  name:"Regine Nkombong Cyrille",
                                  layoff:true,
                                  photo:'https://ca.slack-edge.com/T03MZB4ML81-U04CGC8S17Z-873988e9a07d-512'
                                },
                                {
                                  name:"Gueguim Sonna Zitha Unelle",
                                  layoff:true,
                                  photo:'https://ca.slack-edge.com/T03MZB4ML81-U04H5M7N1DY-d31c10d6d07c-512'
                                },
                                {
                                  name:"Meli Tchouala Imelda",
                                  layoff:true,
                                  photo:'https://ca.slack-edge.com/T03MZB4ML81-U050ZPWMM1D-f64eda49d82b-512'
                                },
                                {
                                  name:"Ngouleu Noumbissi Tertullien",
                                  warning:true,
                                  photo:'https://ca.slack-edge.com/T03MZB4ML81-U03VA870CRF-8cb0ea37140b-512'
                                }
                              ]
                            },
                          ]
                        },

                        {name:"Product",
                        photo:camsol_logo1,
                        report5:[
                          {
                            name:'Jubal Prospère',
                            photo:cms13_jubal,
                            title:'',
                            report6:[
                              {name:"Ulrich Djiofack",
                              uknownPerson:false,
                              photo:'https://ca.slack-edge.com/T03MZB4ML81-U05FYSGTLV6-9565e6a5f603-512'
                            },
                            {
                              name:"Findo Peter Kampete",
                              photo:'https://ca.slack-edge.com/T03MZB4ML81-U0411FAG942-2caff10fa1de-512',
                              layoff:true
                            },
                            {
                              name:"Messi Innocent Rostand",
                              photo:'https://ca.slack-edge.com/T03MZB4ML81-U042QBM8SS2-bc609f4e55ee-512',
                              layoff:true
                            },
                            {
                              name:"Mugri Ndeh Frunwi",
                              layoff:true,
                              photo:'https://ca.slack-edge.com/T03MZB4ML81-U042QCAAZD4-a5f5e7676239-512'
                            }
                            ]
                          },
                        ]
                      },


                         
                          
                          
                        ]
                      },
                     
                    ],
                  },
                  {
                    name:"Brand & Value",
                    photo:camsol_logo1,
                    report3:[
                      {
                        name:'Selina Scherer-Braun ',
                        photo:cms1_CEO,
                        title:'Geschäftsführende Gesellschafterin(Managing Partner) | CEO',
                        phoneNumber:'+49 173 9760212',
                        email:"selina.scherer-braun@camsol.io",
                        website:"camsol.io",
                        address:"Black Forest, a large forested mountain range in south-west Germany",
                        linkedIn:"https://www.linkedin.com/in/schererbraun/",
                        Education:[
                          {
            
                            year:"Oct 2012 - Mar 2017",
                            certificateName:"Bachelor of Arts - BA, Linguistik - Schwerpunkt Computerlinguistik",
                            certificatePoints:"!!!!!!!!Uknown",
                            institutionName:"Ruhr University Bochum",
                          },
            
            
            
            
                        ],
                        languages:[
                          {
                            languageName:"English",
                            languagesPercent:"95%"
                          },
                          {
                            languageName:"German",
                            languagesPercent:"95%"
                          }
                        ],
                        BiographyP1:'Hi, my name is Selina, I am the CEO and founder of Camsol. I live in Saint George in Black Forest, Germany. My passions are social sustainability, computer linguistics and writing. I have two children and am married. In my free time I like to read, listen to music, play computer games or board games, write and work on craft projects.',
                        BiographyP2:"I also recieved some questions about my relation to Tobias.We are married since 2015 and have two children. I am the CEO of Camsol and Tobias supports us, but currently full-tim employed at Haufe Group.I hope in the future he will have more time to work with us",
                        BiographyP3:"",
                        BiographyP4:"",
                        BiographyP5:"",
                        Experience:[
                          {
                            yearsOfExperience:"May 2022 - Present",
                            placeOfExperience:"Camsol Technologies UG (haftungsbeschränkt) Full time",
                            locationOfExperience:"Germany",
                            areaOfExpertise:"Geschäftsführende Gesellschafterin(Managing Partner) | CEO",
                            descOfWorkDoneInAreaOfExpertise:"HR Leader, focused on providing strategic HR Partnering to Executive Vice President Applications. Focused on Optimising Business Performance, Executive Leadership, Organisation Design and Transformation. Responsible for leading a team of Senior HRBPs who align with Camsol based Executives (Senior Vice Presidents / Vice Presidents) within the License Organisation,",
                          },
                          {
                            yearsOfExperience:"Jan 2016 - Present",
                            placeOfExperience:"Zuhause( At home) · Full-time",
                            locationOfExperience:"Germany",
                            areaOfExpertise:"Mutter(mother) Full time",
                            descOfWorkDoneInAreaOfExpertise:"all description of a mother to kids",
                          },
                          {
                            yearsOfExperience:"Apr 2015 - Oct 2019",
                            placeOfExperience:"fothmind GmbH · Full-time",
                            locationOfExperience:"Köln, Nordrhein-Westfalen, Deutschland",
                            areaOfExpertise:"Developer and Consultant",
                            descOfWorkDoneInAreaOfExpertise:"Skills: SAP ERP · Data Science · Python",
                          },
                          {
                            yearsOfExperience:"Jun 2016 - Feb 2017",
                            placeOfExperience:"bee security GmbH · Full-time",
                            locationOfExperience:"Köln, Nordrhein-Westfalen, Deutschland",
                            areaOfExpertise:"Technical Editor",
                            descOfWorkDoneInAreaOfExpertise:"",
                          },
                          {
                            yearsOfExperience:"Apr 2015 - Sep 2015",
                            placeOfExperience:"Ruhr-Universität Bochum · Part-time",
                            locationOfExperience:"",
                            areaOfExpertise:"Studentische Hilfskräfte(student assistants)",
                            descOfWorkDoneInAreaOfExpertise:"Skills: Data Science · Python",
                          },
                          {
                            yearsOfExperience:"ul 2014 - Dec 2014 ",
                            placeOfExperience:"GoToSec GmbH · Full-time",
                            locationOfExperience:"",
                            areaOfExpertise:"SAP Developer",
                            descOfWorkDoneInAreaOfExpertise:"Skills: SAP ERP · ABAP · Groovy · Python",
                          },
            
            
                        ],
                        professionalSkills:[
                          {
            
                            nameOfSkill:"SAP Developer at GoToSec GmbH",
                            persentageOfSkills:"95%",
                          },
            
            
                        ],
                        Interest:[
                          {
                            // iconOfInterest:"",
                            // nameOfInterest:"",
                          }
                        ],
                        source:[
                          {
                            name:"LinkedIn",
                            link:"https://www.linkedin.com/in/schererbraun/"
                          },
                          {
                            name:"Notion",
                            link:"https://www.notion.so/camsol/44d1d0a072624df9a5ab29d6bbc7b20a?v=c3a189c055474561b63f6a0a7741121e"
                          },
            
            
                        ],
            
                          report4:[
                            // {
                            //   name:'Azimi Zubai Yakubu (Morgan Kehlani)',
                            //   photo:'https://ca.slack-edge.com/T03MZB4ML81-U03MZ8N6F51-103ec47f9e50-512',
                            //   title:'',
                            // },
                            {name:"Data Science",
                            photo:camsol_logo1,
                            report5:[
                              {
                              name:'Kongnyu Carine',
                              photo:cms6_carine,
                              title:'team lead',
                              report6:[
                                {
                                  name:'Ngoran Bedes Tomnyuy',
                                  photo:cms7_Ngoran,
                                  title:''
                                },
                                {
                                  name:'Elmander Elmer',
                                  layoff:true,
                                  photo:cms8_Elma,
                                  title:''
                                },
                                {
                                  name:"Tanjoh Noel Nchong",
                                  layoff:true
                                },
                                {
                                  name:"Mopock Talla Ceverine Thalitha",
                                  intern:true,
                                  promotion:false,
                                  layoff:true,
                                  photo:"https://ca.slack-edge.com/T03MZB4ML81-U03RQLEPT99-35531305936b-512",
                                  promotionDate:"01/09/2023",
                                  promotionTo:"fullstack"
                                }
                              ]
                            },
                            ]
                          },

                          {name:"Brand",
                            photo:camsol_logo1,
                            report5:[
                              {
                                name:'Alke Schmidt',
                                photo:cms23_Schmidt,
                                title:'team lead',
                              }
                            ]
                          },
                            
                            
                            
                          ]
            
                      }
                    ]
                  },
                  {
                    name:"Cyber Security",
                    photo:camsol_logo1,
                    report3:[
                      {
                        name:'Simon Ngafeeson',
                        photo:cms21_simon,
                        title:'team lead',
                        BiographyP1:'ask him ?????????????????? or find out form slack',
                        source:[
                          {
                            name:"unknown???????",
                            link:"??????"
                          }
                        ],
                        report4:[
                          {
                            name:"Fuanjia Nkengfua Christopher",
                            layoff:true,
                            photo:'https://ca.slack-edge.com/T03MZB4ML81-U06BA2FPD9T-57f8bf4a86ae-512'

                          },
                          {
                            name:"Fondanui Kelly Tasha",
                            photo:"https://ca.slack-edge.com/T03MZB4ML81-U0402DGF7D0-f64a2d0a85a5-512",
                            layoff:true
                          },
                          {
                            name:"Fotsop Buea Luca",
                            photo:"https://ca.slack-edge.com/T03MZB4ML81-U049EL3RVU0-4b842a5f429e-512",
                            layoff:true
                          },
                          {
                            name:"Aze Desmond Nembo",
                            photo:'https://ca.slack-edge.com/T03MZB4ML81-U03QWH0V292-1a04f6e910d3-512'
                          },
                          {
                            name:"Fondanui Kelly Tasha",
                            layoff:true
                          },
                          {
                            name:"Tambe Salome Ntoh",
                            layoff:true
                          }
                        ]
                      },
                     
                    ],
                  },
                  {
                    name:"Director of Engineering",
                    photo:camsol_logo1,
                    report3:[
                      {
                        name:"Frontend of Engineering",
                        photo:camsol_logo1,
                        report4:[
                          {
                            name:'Jume Brice',
                            photo:cms16_Jume,
                            title:'Ask him ???????????????',
                            BiographyP1:'ask him ?????????????????? or find out form slack',
                            source:[
                              {
                                name:"unknown???????",
                                link:"??????"
                              }
                            ],
                            report5:[
                              {
                                name:'FrontEnd Team 1',
                                photo:camsol_logo1,
                                report6:[
                                  {
                                    name:"Lowe Silcanus",
                                    layoff:true,
                                    photo:'https://ca.slack-edge.com/T03MZB4ML81-U03MS48PS7R-4bb456688b17-512',
                                    report7:[
                                      {
                                        name:"Acha Achubang",
                                        layoff:true,
                                        photo:'https://ca.slack-edge.com/T03MZB4ML81-U041XTLR5T5-706421c9b519-512',
                                        warning:true
                                      },
                                      {
                                        name:'Nkenfa Nkombong Brandon',
                                        layoff:true,
                                        photo:'https://ca.slack-edge.com/T03MZB4ML81-U03NY0ATUR0-4ae18be44b1b-512',
                                      },
                                      {
                                        name:'Queen Laure Ngum Nfongeh',
                                        photo:'https://ca.slack-edge.com/T03MZB4ML81-U055NSMH4KY-abbb4fea00b8-512'
                                      },
                                      {
                                        name:"Chu Edwin Gah",
                                        photo:'https://ca.slack-edge.com/T03MZB4ML81-U044MT74P5K-fba87333acbd-512'
                                      },
                                      {
                                        name:"Wuyika Serge Kevin",
                                        photo:'https://ca.slack-edge.com/T03MZB4ML81-U03RMTW7LH3-31d878429d44-512'
                                      },
                                      {
                                        name:"Carine Gije Nfor",
                                        layoff:true
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                name:'FrontEnd Team 2',
                                photo:camsol_logo1,
                                report6:[
                                  {
                                    name:"Prince Junior",
                                    photo:'https://ca.slack-edge.com/T03MZB4ML81-U04CJ9WMVBK-cba0f8afbabd-512',
                                    report7:[
                                        {
                                          name:"Apoh Prince Eldrige",
                                          photo:'https://ca.slack-edge.com/T03MZB4ML81-U04GR131DPZ-1f24be3715b1-512',
                                        },
                                        {
                                          name:"Atem Randy Asong",
                                          photo:'https://ca.slack-edge.com/T03MZB4ML81-U04HD9MLCM7-fb37611438ae-512',
                                          layoff:true
                                        },
                                        {
                                          name:"Fomonyuytar Joseph",
                                          photo:"https://ca.slack-edge.com/T03MZB4ML81-U056CAWF1ME-198fec6652ca-512"
                                        },
                                        {
                                          name:"Bradon Mbianou",
                                          uknownPerson:false,
                                          photo:"https://ca.slack-edge.com/T03MZB4ML81-U05CDV7015K-46cf92165291-512",
                                        },
                                        {
                                          name:"Nchia Emmanuela Ekei",
                                          photo:"https://ca.slack-edge.com/T03MZB4ML81-U04M3KGMZ62-9a364dc60f34-512"
                                        },
                                        {
                                          name:"Nkwetakem Tabo Bruno",
                                          layoff:true,
                                          photo:"https://ca.slack-edge.com/T03MZB4ML81-U04S2T1PW6M-33f481231569-512"
                                        }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                         
                        ],
                      },

                      {
                        name:"Backend of Engineering",
                        photo:camsol_logo1,
                        report4:[
                          {
                            name:'Nnouka Stephen',
                            photo:cms25_Stephen,
                            title:'Ask him ???????????????',
                            layoff:true,
                            BiographyP1:'ask him ?????????????????? or find out form slack',
                            source:[
                              {
                                name:"unknown???????",
                                link:"??????"
                              }
                            ],
                            report5:[
                              {
                                name:'Backend Team 1',
                                photo:camsol_logo1,
                                report6:[
                                  {
                                    name:"Nkoa Chistophe",
                                    photo:'https://ca.slack-edge.com/T03MZB4ML81-U03NZ3K3SUT-d16201de00e5-512',
                                    report7:[
                                      {
                                        name:'Nde Che Lucien Ngwa',
                                        layoff:true
                                      },
                                      {
                                        name:'Norbert Ndip Etta',
                                         photo:'https://ca.slack-edge.com/T03MZB4ML81-U04GNUB93BR-0e23f80f6af8-512',
                                         report8:[
                                            {
                                              name:"Fonyuy Verena Monyuuta-ah"
                                            }
                                         ]
                                      },
                                      {
                                        name:'Peng Boris Akebuon',layoff:true,photo:'https://ca.slack-edge.com/T03MZB4ML81-U04RQ4Z6JNN-5ab958efa408-512',
                                      },
                                      {
                                        name:'Brian Atanga Muma',layoff:true,photo:'https://ca.slack-edge.com/T03MZB4ML81-U04293X9XCZ-709d19a29303-512',
                                      },
                                      {
                                        name:'Samuel Tiokeng',
                                        phoneNumber:'+237-670-922-061',
                                        email:"samueledward40@gmail.com",
                                        uknownPerson:false,
                                        photo:"https://ca.slack-edge.com/T03MZB4ML81-U05EM1LQARZ-c6ff6369653e-512",
                                        sickLeaveDayNumber:"1",
                                        sickLeaveExplain:[
                                          {reason:"This is Samuel Tiokeng from the Backend Team at Camsol. I am writing regarding the sick leave I took for on Monday 3rd of June. I went to the Mbingo Hospital in Douala and had expenses worth 16,000FCFA.  I had some weekness in my Joints for some time now and I had to consult for it because it was taking a toll on my productivity. This is how the expenses went at the hospital - Registration: 1000FCFA, - Tests: 7000FCF - Drugs: 8000FCFA Which gives a total of 16000FCFA for my hospital expenses. I was hoping for assistance with these medical expenses as the contract says concerning health insurance. Attached to this are pictures highlighting those expenses in my medical booklet",
                                            date:"03-06-2024",
                                            paid:"yes",
                                            amount:"16000",
                                            paidDate:"06-06-2024",
                                            supportingDocs:[
                                              {doc:Samuel_Tiokeng1},
                                              {doc:Samuel_Tiokeng2},
                                              {doc:Samuel_Tiokeng3}
                                            ]
                                            
                                          },

                                        ]

                                      },
                                      {
                                        name:'Domou Namou Brice Armel',
                                      },
                                    ]
                                  }
                                ]
                              },
                              {
                                name:'Backend Team 2',
                                photo:camsol_logo1,
                                report6:[
                                  {
                                    name:"Fru Boris",
                                    photo:'https://ca.slack-edge.com/T03MZB4ML81-U04GYUW55HC-29cc7f71d153-512',
                                    report7:[
                                        {
                                          name:"Billy Hans Weno Ndum",
                                          layoff:true
                                        },
                                        {name:"Nji Kebei Daniel Koum",
                                        layoff:true
                                      },
                                        {name:"Djomo Nkwuatchou Brown Alden" , layoff:true,photo:'https://ca.slack-edge.com/T03MZB4ML81-U03N1P4CNN8-4430a45d63ea-512'},
                                        {name:"Asonglefac Millenium Nzefe", layoff:true,photo:"https://ca.slack-edge.com/T03MZB4ML81-U03V3MJ5G5V-67da3b2e7d46-512"},
                                        {name:"Sonwa Boris Roberto", photo:"https://ca.slack-edge.com/T03MZB4ML81-U04RMHN4S6R-4d753f5dad94-512"}
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                         
                        ],
                      },
                     
                     
                    ],
                  },
                  {
                    name:"quality and assurance",
                    photo:camsol_logo1,
                    layoff:true,
                    report3:[
                      {
                        name:'Herbert Mbangzieu',
                        photo:cms24_Herbert,
                        title:'team lead',
                        transfered:true,
                        layoff:true,
                        BiographyP1:'ask him ?????????????????? or find out form slack',
                        source:[
                          {
                            name:"unknown???????",
                            link:"??????"
                          }
                        ],
                        report4:[
                          {
                            name:'Yannick Njume',
                            layoff:true,
                            photo:'https://ca.slack-edge.com/T03MZB4ML81-U041Z74A47N-09896a5e2457-512'
                          },
                          {
                            name:'Asonganyi Rouclec',
                            photo:'https://ca.slack-edge.com/T03MZB4ML81-U044Q1KTR6H-8b25e5b9a14b-512'
                          }
                        ]
                      },
                     
                    ],
                  },
                ]
              },
            ]
          },
          {
            name:"Execution & Finance",
            photo:camsol_logo1,
            report1:[
              {
                name:'Maximilian Betz',
                photo:cms2_max,
                title:'Managing Director, responsible for Legal and Finance and Holding Management',
                BiographyP1:'ask him ?????????????????? or find out form slack',
                source:[
                  {
                    name:"unknown???????",
                    link:"??????"
                  }
                ],
                report2:[
                  {
                    name:'Mohamad Siysinyuy Banbong',
                    photo:'https://avatars.githubusercontent.com/u/40745841?v=4',
                    title:'Country Manager',
                    report3:[
                      {
                        name:'Alice Ndeh',
                        layoff:true,
                        photo:cms5_Alice,
                        title:'team lead',
                        report4:[
                          {
                            name:'Ngang Muma',
                            photo:cms9_Muma,
                            layoff:true,
                            title:''
                          },
                          {
                            name:'Signe Eric',
                            photo:cms10_eric,
                            layoff:true,
                            title:''
                          },
                        ]
                      },
                      {
                        name:'Adidjatou Tsedoumo Hawa Dahli',
                        photo:'https://ca.slack-edge.com/T03MZB4ML81-U06DM78MX5M-c4ff217b83cd-512',
                        title:'HR/PA',
                        sickLeaveDayNumber:"1",
                        sickLeaveExplain:[
                          {reason:"Dear Manager,I hope this message finds you well. I am writing to request a day off from work due to health concerns that I believe may impact my ability to perform effectively. I kindly ask for your understanding and approval for this time off to ensure I can address these health issues promptly. I will keep you updated on my status and ensure that any urgent tasks are handled accordingly. Thank you for your consideration. Best regards,Miss. Adidjatou T. Hawa Dahli ",
                            date:"24-06-2024",
                            paid:"no",
                            amount:"",
                            paidDate:"",
                            supportingDocs:[
                              {doc:Hawa_1},
                            ]
                            
                          },
    
                        ]
                      }
                      
                      
                    ]
                  },
                  {
                    name:'David',
                    photo:cms18_david,
                    title:'Sales',
                    
                  },
                  {
                    name:'Jeanne Monstadt',
                    photo:cms15_jeanne,
                    title:'Investments'
                  },
                ]
              },
            ]
          },
          
          
          
          {
            name:"Board of Directors",
            photo:camsol_logo1,
            report1:[
            {
              name:'Tobias Braun',
              photo:cms4_Tobi,
              title:'CTO and CHRO',
              BiographyP1:'ask him ?????????????????? or find out form slack',
                source:[
                  {
                    name:"unknown???????",
                    link:"??????"
                  }
                ]
            },
              {
                name:'Maximilian Betz',
                photo:cms2_max,
                title:'Ask him ???????????????',
                BiographyP1:'ask him ?????????????????? or find out form slack',
                source:[
                  {
                    name:"unknown???????",
                    link:"??????"
                  }
                ]
              },
              {
    
                name:'Selina Scherer-Braun ',
                photo:cms1_CEO,
                title:'Geschäftsführende Gesellschafterin(Managing Partner) | CEO',
                phoneNumber:'+49 173 9760212',
                email:"selina.scherer-braun@camsol.io",
                website:"camsol.io",
                address:"Black Forest, a large forested mountain range in south-west Germany",
                linkedIn:"https://www.linkedin.com/in/schererbraun/",
                Education:[
                  {
    
                    year:"Oct 2012 - Mar 2017",
                    certificateName:"Bachelor of Arts - BA, Linguistik - Schwerpunkt Computerlinguistik",
                    certificatePoints:"!!!!!!!!Uknown",
                    institutionName:"Ruhr University Bochum",
                  },
    
    
    
    
                ],
                languages:[
                  {
                    languageName:"English",
                    languagesPercent:"95%"
                  },
                  {
                    languageName:"German",
                    languagesPercent:"95%"
                  }
                ],
                BiographyP1:'Hi, my name is Selina, I am the CEO and founder of Camsol. I live in Saint George in Black Forest, Germany. My passions are social sustainability, computer linguistics and writing. I have two children and am married. In my free time I like to read, listen to music, play computer games or board games, write and work on craft projects.',
                BiographyP2:"I also recieved some questions about my relation to Tobias.We are married since 2015 and have two children. I am the CEO of Camsol and Tobias supports us, but currently full-tim employed at Haufe Group.I hope in the future he will have more time to work with us",
                BiographyP3:"",
                BiographyP4:"",
                BiographyP5:"",
                Experience:[
                  {
                    yearsOfExperience:"May 2022 - Present",
                    placeOfExperience:"Camsol Technologies UG (haftungsbeschränkt) Full time",
                    locationOfExperience:"Germany",
                    areaOfExpertise:"Geschäftsführende Gesellschafterin(Managing Partner) | CEO",
                    descOfWorkDoneInAreaOfExpertise:"HR Leader, focused on providing strategic HR Partnering to Executive Vice President Applications. Focused on Optimising Business Performance, Executive Leadership, Organisation Design and Transformation. Responsible for leading a team of Senior HRBPs who align with Camsol based Executives (Senior Vice Presidents / Vice Presidents) within the License Organisation,",
                  },
                  {
                    yearsOfExperience:"Jan 2016 - Present",
                    placeOfExperience:"Zuhause( At home) · Full-time",
                    locationOfExperience:"Germany",
                    areaOfExpertise:"Mutter(mother) Full time",
                    descOfWorkDoneInAreaOfExpertise:"all description of a mother to kids",
                  },
                  {
                    yearsOfExperience:"Apr 2015 - Oct 2019",
                    placeOfExperience:"fothmind GmbH · Full-time",
                    locationOfExperience:"Köln, Nordrhein-Westfalen, Deutschland",
                    areaOfExpertise:"Developer and Consultant",
                    descOfWorkDoneInAreaOfExpertise:"Skills: SAP ERP · Data Science · Python",
                  },
                  {
                    yearsOfExperience:"Jun 2016 - Feb 2017",
                    placeOfExperience:"bee security GmbH · Full-time",
                    locationOfExperience:"Köln, Nordrhein-Westfalen, Deutschland",
                    areaOfExpertise:"Technical Editor",
                    descOfWorkDoneInAreaOfExpertise:"",
                  },
                  {
                    yearsOfExperience:"Apr 2015 - Sep 2015",
                    placeOfExperience:"Ruhr-Universität Bochum · Part-time",
                    locationOfExperience:"",
                    areaOfExpertise:"Studentische Hilfskräfte(student assistants)",
                    descOfWorkDoneInAreaOfExpertise:"Skills: Data Science · Python",
                  },
                  {
                    yearsOfExperience:"ul 2014 - Dec 2014 ",
                    placeOfExperience:"GoToSec GmbH · Full-time",
                    locationOfExperience:"",
                    areaOfExpertise:"SAP Developer",
                    descOfWorkDoneInAreaOfExpertise:"Skills: SAP ERP · ABAP · Groovy · Python",
                  },
    
    
                ],
                professionalSkills:[
                  {
    
                    nameOfSkill:"SAP Developer at GoToSec GmbH",
                    persentageOfSkills:"95%",
                  },
    
    
                ],
                Interest:[
                  {
                    // iconOfInterest:"",
                    // nameOfInterest:"",
                  }
                ],
                source:[
                  {
                    name:"LinkedIn",
                    link:"https://www.linkedin.com/in/schererbraun/"
                  },
                  {
                    name:"Notion",
                    link:"https://www.notion.so/camsol/44d1d0a072624df9a5ab29d6bbc7b20a?v=c3a189c055474561b63f6a0a7741121e"
                  },
    
    
                ],
    
              },
             
            ]
          }
        ]
      },
      {
        name:"CAMSOL CAMEROON",
        people:[
          
                {
                  name:"Board of Directors",
                  report1:[
                    {
                      name:'Maximilian Betz',
                      photo:cms2_max,
                      title:'Ask him ???????????????',
                      BiographyP1:'ask him ?????????????????? or find out form slack',
                      source:[
                        {
                          name:"unknown???????",
                          link:"??????"
                        }
                      ]
                    },
                    {

                      name:'Selina Scherer-Braun ',
                      photo:cms1_CEO,
                      title:'Geschäftsführende Gesellschafterin(Managing Partner) | CEO',
                      phoneNumber:'+49 173 9760212',
                      email:"selina.scherer-braun@camsol.io",
                      website:"camsol.io",
                      address:"Black Forest, a large forested mountain range in south-west Germany",
                      linkedIn:"https://www.linkedin.com/in/schererbraun/",
                      Education:[
                        {

                          year:"Oct 2012 - Mar 2017",
                          certificateName:"Bachelor of Arts - BA, Linguistik - Schwerpunkt Computerlinguistik",
                          certificatePoints:"!!!!!!!!Uknown",
                          institutionName:"Ruhr University Bochum",
                        },




                      ],
                      languages:[
                        {
                          languageName:"English",
                          languagesPercent:"95%"
                        },
                        {
                          languageName:"German",
                          languagesPercent:"95%"
                        }
                      ],
                      BiographyP1:'Hi, my name is Selina, I am the CEO and founder of Camsol. I live in Saint George in Black Forest, Germany. My passions are social sustainability, computer linguistics and writing. I have two children and am married. In my free time I like to read, listen to music, play computer games or board games, write and work on craft projects.',
                      BiographyP2:"I also recieved some questions about my relation to Tobias.We are married since 2015 and have two children. I am the CEO of Camsol and Tobias supports us, but currently full-tim employed at Haufe Group.I hope in the future he will have more time to work with us",
                      BiographyP3:"",
                      BiographyP4:"",
                      BiographyP5:"",
                      Experience:[
                        {
                          yearsOfExperience:"May 2022 - Present",
                          placeOfExperience:"Camsol Technologies UG (haftungsbeschränkt) Full time",
                          locationOfExperience:"Germany",
                          areaOfExpertise:"Geschäftsführende Gesellschafterin(Managing Partner) | CEO",
                          descOfWorkDoneInAreaOfExpertise:"HR Leader, focused on providing strategic HR Partnering to Executive Vice President Applications. Focused on Optimising Business Performance, Executive Leadership, Organisation Design and Transformation. Responsible for leading a team of Senior HRBPs who align with Camsol based Executives (Senior Vice Presidents / Vice Presidents) within the License Organisation,",
                        },
                        {
                          yearsOfExperience:"Jan 2016 - Present",
                          placeOfExperience:"Zuhause( At home) · Full-time",
                          locationOfExperience:"Germany",
                          areaOfExpertise:"Mutter(mother) Full time",
                          descOfWorkDoneInAreaOfExpertise:"all description of a mother to kids",
                        },
                        {
                          yearsOfExperience:"Apr 2015 - Oct 2019",
                          placeOfExperience:"fothmind GmbH · Full-time",
                          locationOfExperience:"Köln, Nordrhein-Westfalen, Deutschland",
                          areaOfExpertise:"Developer and Consultant",
                          descOfWorkDoneInAreaOfExpertise:"Skills: SAP ERP · Data Science · Python",
                        },
                        {
                          yearsOfExperience:"Jun 2016 - Feb 2017",
                          placeOfExperience:"bee security GmbH · Full-time",
                          locationOfExperience:"Köln, Nordrhein-Westfalen, Deutschland",
                          areaOfExpertise:"Technical Editor",
                          descOfWorkDoneInAreaOfExpertise:"",
                        },
                        {
                          yearsOfExperience:"Apr 2015 - Sep 2015",
                          placeOfExperience:"Ruhr-Universität Bochum · Part-time",
                          locationOfExperience:"",
                          areaOfExpertise:"Studentische Hilfskräfte(student assistants)",
                          descOfWorkDoneInAreaOfExpertise:"Skills: Data Science · Python",
                        },
                        {
                          yearsOfExperience:"ul 2014 - Dec 2014 ",
                          placeOfExperience:"GoToSec GmbH · Full-time",
                          locationOfExperience:"",
                          areaOfExpertise:"SAP Developer",
                          descOfWorkDoneInAreaOfExpertise:"Skills: SAP ERP · ABAP · Groovy · Python",
                        },


                      ],
                      professionalSkills:[
                        {

                          nameOfSkill:"SAP Developer at GoToSec GmbH",
                          persentageOfSkills:"95%",
                        },


                      ],
                      Interest:[
                        {
                          // iconOfInterest:"",
                          // nameOfInterest:"",
                        }
                      ],
                      source:[
                        {
                          name:"LinkedIn",
                          link:"https://www.linkedin.com/in/schererbraun/"
                        },
                        {
                          name:"Notion",
                          link:"https://www.notion.so/camsol/44d1d0a072624df9a5ab29d6bbc7b20a?v=c3a189c055474561b63f6a0a7741121e"
                        },


                      ],

                    },
                    {
                      name:'Mohamad Siysinyuy Banbong',
                            photo:cms3_moh,
                            title:'Megaminds team lead(full stack developer)',
                            
                    },
                  ]
                }
        ]
      },
      
    ],
  }

]
